import { Box, Button, IconButton, useDisclosure } from '@chakra-ui/react'
import { NewInterval } from './NewInterval'
import { useState } from 'react'
import { MdAdd } from 'react-icons/md'
import { IntervalWrapper } from './styled'
import { buildPeriodPreview } from '../ScheduleSessionConfig'

export const MultiDayInterval = ({ schedule, onSave }) => {
    const [intervals, setIntervals] = useState([])
    const { onOpen, onClose, isOpen } = useDisclosure()

    const handleSave = () => {
        const boilerplate = {
            '@ArbitrarySessionCfg': {
                schedulePoints: intervals
            }
        }
        onSave(boilerplate)
    }

    const handleAddInterval = (int) => {
        setIntervals([...intervals, ...int])
        onClose()
    }

    return (
        <Box display="flex" flexDir="column" alignItems="center" justifyContent="center">
            {!isOpen && (
                <>
                    {!!intervals.length ? (
                        intervals
                            .reduce(function(result, value, index, array) {
                                if (index % 2 === 0)
                                    result.push(array.slice(index, index + 2));
                                return result;
                            }, [])
                            .map((interval) => <IntervalWrapper style={{ marginBottom: '16px' }}>{buildPeriodPreview(interval[0], interval[1])}</IntervalWrapper>)
                    ) : (
                        <div style={{ marginBottom: '8px' }}>No intervals</div>
                    )}
                    <IconButton
                        aria-label="Add Schedule Interval"
                        fontSize="20px"
                        marginBottom={4}
                        alignSelf="center"
                        onClick={onOpen}
                        icon={<MdAdd size="30px" />}
                    />
                </>
            )}
            {isOpen && <NewInterval onAddInterval={handleAddInterval} />}
            {!isOpen && (
                <Button onClick={handleSave}
                        isDisabled={!intervals.length}
                        >
                    Save
                </Button>
            )}
        </Box>
    )
}
